import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.wine.rangeAccessibility ? _c("div", [_c(VMenu, {
    attrs: {
      top: "",
      "offset-y": "",
      "open-on-hover": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c("div", _vm._g(_vm._b({
          staticClass: "text-smaller"
        }, "div", attrs, false), on), [_c("i", {
          staticClass: "fas fa-info-circle"
        }), _vm._v(" " + _vm._s("Reserved for " + _vm.listWineRangeAccessibility.find(function (x) {
          return x.id == _vm.wine.rangeAccessibility;
        }).textForUsers) + " ")])];
      }
    }], null, false, 197521103)
  }, [_c(VList, {
    staticClass: "range-list",
    attrs: {
      rounded: ""
    }
  }, [_vm._l(_vm.getMissingAmounts(), function (missingAmount, index) {
    return _c(VListItem, {
      key: index
    }, [_c(VListItemTitle, [index !== 0 ? _c(VDivider, {
      staticClass: "item-divider"
    }) : _vm._e(), _vm._v(" " + _vm._s(missingAmount) + " ")], 1)], 1);
  }), _c(VDivider, {
    staticClass: "item-divider"
  }), _c("a", {
    on: {
      click: function click($event) {
        return _vm.openToS("#privilege-offer");
      }
    }
  }, [_vm._v("More details")])], 2)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };